<div  mat-dialog-title>{{ 'SUPPORT.support' | translate}}<div class="spacer"></div><mat-icon mat-dialog-close>close</mat-icon></div>
<mat-dialog-content >
    <p><span class="mat-subtitle-1">{{ 'SUPPORT.helpSupport' | translate }}</span> &nbsp; &nbsp; <a [href]="helpDeskConfig.resourceCenter" target="_blank">{{ 'SUPPORT.amResourceCenter' | translate }}</a></p>
    <p>{{ 'SUPPORT.supportDetails' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="start" class="mat-subtitle-1">
   {{'SUPPORT.reportProblem' | translate}} &nbsp; &nbsp; <a (click)="openSupportTicketFormDialog()">{{ 'SUPPORT.createTicket' | translate }}</a>
</mat-dialog-actions>